import React from 'react';

function Logo({ size = 40, className = 'logo', title = 'MenuVivo', ariaHidden = false }) {
  const px = typeof size === 'number' ? `${size}px` : size;
  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
      aria-hidden={ariaHidden}
      className={className}
    >
      <defs>
        <linearGradient id="mv-gradient" x1="0" x2="1" y1="0" y2="1">
          <stop offset="0" stopColor="var(--accent)" />
          <stop offset="1" stopColor="var(--accent-2)" />
        </linearGradient>
      </defs>
  <rect x="0" y="0" width="80" height="80" rx="14" fill="url(#mv-gradient)" />
      <text
        x="50%"
        y="55%"
        textAnchor="middle"
        fontFamily="Inter, sans-serif"
        fontWeight="700"
        fontSize="36"
  fill="var(--on-surface)"
      >
        MV
      </text>
    </svg>
  );
}

export default Logo;
